import { render } from "./ToolButtons.vue?vue&type=template&id=78c225b3&ts=true"
import script from "./ToolButtons.vue?vue&type=script&lang=ts"
export * from "./ToolButtons.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/thomaswang/Workspace/Latipay/FlashFxUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__